import { render, staticRenderFns } from "./addverify.vue?vue&type=template&id=6e5c0781&scoped=true&"
import script from "./addverify.vue?vue&type=script&lang=js&"
export * from "./addverify.vue?vue&type=script&lang=js&"
import style0 from "./addverify.vue?vue&type=style&index=0&id=6e5c0781&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5c0781",
  null
  
)

export default component.exports